import React, { useState, useRef } from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import AppContainer from './common/layout/AppContainer'
import { fetchCrossBrowserCSS, isBadBrowser, renderBadBrowserMessage } from './common/crossBrowser'
import AuthProvider from './auth/auth-provider'
import { authConfigEndpoints } from './auth/auth-client.http'

fetchCrossBrowserCSS()

// Main provider component that doesn't use Redux hooks
const AppProvider = ({ store, history }) => {
  const initialized = useRef()
  const [initializedConfig, setInitializedConfig] = useState(false)
  const [authConfig, setAuthConfig] = useState()

  if (!initialized.current) {
    initialized.current = true
    const getConfig = async () => {
      try {
        // Fetch auth configuration from the specified endpoint
        const response = await authConfigEndpoints.GET_CONFIG()
        setAuthConfig({
          use_frame: response?.use_frame || true,
        })
      } catch (error) {
        console.error('Error fetching auth configuration:', error)
        setAuthConfig({
          use_frame: true,
        })
      } finally {
        setInitializedConfig(true)
      }
    }
    getConfig()
  }

  // Handle browser compatibility - can be done outside Redux
  if (isBadBrowser) {
    return renderBadBrowserMessage
  }


  if (!initialized.current || !initializedConfig || authConfig === undefined) {
    return null
  }

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AuthProvider authConfig={authConfig}>
          <AppContainer />
        </AuthProvider>
      </ConnectedRouter>
    </Provider>
  )
}

// Export the app component (Vite handles HMR automatically)
export default AppProvider
